import React, { ReactNode } from 'react';
import styles from './CoffeeSticker.module.scss';

interface CoffeeStickerProps {
  children: ReactNode;
  isLargeSize?: boolean;
  className?: string;
}

const CoffeeSticker: React.FC<CoffeeStickerProps> = ({ children, className }) => {
  return (
    <div className={styles.coffeeSticker}>
      <span className={[styles.bottomRight, className].filter(Boolean).join(' ')}>
        {children}
      </span>
    </div>
  );
};

export default CoffeeSticker;
